// NPM
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

class ResultsNavigationButton extends Component {
  getButtonInfo = () => {
    const { path, resultUUID } = this.props;
    let text, url;

    if (path === 'favorite') {
      text = 'Favorites';
      url = `/results/${resultUUID}/favourites`;
    } else if (path === 'hidden') {
      text = 'Hidden';
      url = '/results/hidden';
    } else {
      text = 'Results';
      url = `/results/${resultUUID}`;
    }
    return { url, text };
  };

  render() {
    const buttonInfo = this.getButtonInfo();
    const { className } = this.props;

    return (
      <Link
        to={buttonInfo.url}
        href={buttonInfo.url}
        className={`ResultsNavigationButton btn ${this.props.path}-results ${
          className ? className : ''
        }`}
      >
        <span>{buttonInfo.text}</span>
      </Link>
    );
  }
}

ResultsNavigationButton.propTypes = {
  path: PropTypes.oneOf(['favorite', 'hidden', 'index']).isRequired,
  resultUUID: PropTypes.string,
};

export default ResultsNavigationButton;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ResultsNavigationButton.js